
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class CPDTime extends React.Component {

    _getHoursIcons() {

        const hours = this.props.hours.split('');

        return this._getIcons(hours);
    }

    _getMinuteIcons() {

        const minutes = this.props.minutes.split('');

        return this._getIcons(minutes);
    }

    _getIcons(digits) {

        return digits.map((digit, index) => {

            return <img key={ index }
                        styleName="digit"
                        src={ `/assets/images/icons/matrix_numbers/${ digit }.png` }
                        style={ this.props.style }
                        />;
        });
    }

    render() {

        return (
            <div styleName="container">

                { this._getHoursIcons() }

                <span styleName="dot" style={ this.props.style }/>

                { this._getMinuteIcons() }

            </div>
        );
    }
}

export default CSSModules(CPDTime, style);


// WEBPACK FOOTER //
// ./components/CPDTime/index.js